import React from 'react';

const CoreValues = () => {
  const values = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 5L15 15H25L20 5Z" fill="white"/>
          <path d="M8 18L18 13V23L8 18Z" fill="white"/>
          <path d="M32 18L22 13V23L32 18Z" fill="white"/>
          <path d="M12 25H28L25 35H15L12 25Z" fill="white"/>
          <circle cx="20" cy="20" r="3" fill="white"/>
        </svg>
      ),
      title: "Exceed Client Expectations"
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 8L24 16H32L26 22L28 30L20 26L12 30L14 22L8 16H16L20 8Z" fill="white"/>
          <circle cx="20" cy="12" r="2" fill="white"/>
          <circle cx="16" cy="18" r="1.5" fill="white"/>
          <circle cx="24" cy="18" r="1.5" fill="white"/>
          <circle cx="20" cy="24" r="1.5" fill="white"/>
        </svg>
      ),
      title: "Pursue Excellence"
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="10" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M20 12V20L26 26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="20" cy="20" r="2" fill="white"/>
          <path d="M12 8L16 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M28 8L24 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M32 20H28" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Build for the Long-Term"
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="8" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M16 20L19 23L24 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 10L15 15" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M30 10L25 15" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M30 30L25 25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M10 30L15 25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Embrace Change and Innovation"
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="12" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M12 20C12 15.5 15.5 12 20 12C24.5 12 28 15.5 28 20" stroke="white" strokeWidth="2"/>
          <circle cx="15" cy="18" r="2" fill="white"/>
          <circle cx="25" cy="18" r="2" fill="white"/>
          <path d="M14 25H26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Work as One Global Team"
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 8C16 8 13 11 13 15C13 19 20 25 20 25S27 19 27 15C27 11 24 8 20 8Z" stroke="white" strokeWidth="2" fill="white"/>
          <circle cx="20" cy="15" r="3" fill="#2B6CB0"/>
          <path d="M15 28H25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M12 32H28" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Be a Caring Meritocracy"
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="8" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M25 25L32 32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M20 10V20" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M10 15H20" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="30" cy="12" r="3" fill="white"/>
        </svg>
      ),
      title: "Drive Commercial Rigor"
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 20L18 26L28 14" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="20" cy="20" r="15" stroke="white" strokeWidth="2" fill="none"/>
        </svg>
      ),
      title: "Always Act with Integrity"
    }
  ];

  return (
    <div className="container-fluid py-5"
     data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
    >
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <h1 style={{  
              fontWeight: 'bold', 
              fontSize: '3rem',
              marginBottom: '3rem'
            }}
            className='text-danger'
            >
              Our Core Values
            </h1>
          </div>
        </div>
        
        <div className="row g-4">
          {values.map((value, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div 
                className="text-center h-100 p-4"
                style={{
                  background: 'transparent',
                  border: 'none'
                }}
              >
                <div 
                  className="d-flex align-items-center justify-content-center mb-3 mx-auto position-relative"
                  style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(135deg, #eb2525ff 0%, #af1e1ebf 100%)',
                    borderRadius: '20px',
                    transform: 'rotate(45deg)',
                    // boxShadow: '0 8px 25px rgba(235, 37, 37, 0.3)'
                  }}
                >
                  <div 
                    style={{ 
                      // transform: 'rotate(-45deg)',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%) rotate(-45deg)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {value.icon}
                  </div>
                </div>
                
                <h5 
                  className="fw-bold"
                  style={{ 
                    color: '#000000ff',
                    fontSize: '1.25rem',
                    lineHeight: '1.4',
                    marginTop: '1rem'
                  }}
                >
                  {value.title}
                </h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoreValues;